import React, { FunctionComponent } from "react";
import cx from "classnames";
import { Text } from "@smartsuite/react-ui/lib/components/typography/Text/Text";
import { Icon } from "@smartsuite/react-ui/lib/components/utils/Icon/Icon";

interface CustomPickerColorProps {
  className?: string;
  selectedColor: string | undefined;
  colors: string[];

  onAddCustomColor: () => void;
  onChange: (customColor: string) => void;
}

export const CustomPickerColor: FunctionComponent<CustomPickerColorProps> = ({
  className,
  selectedColor,
  colors,

  onAddCustomColor,
  onChange,
}) => {
  const classes = cx(className, "custom-picker-color");
  return (
    <div className={classes}>
      <Text
        className="custom-picker-color__title"
        size="xs"
        color="secondary"
        weight="semibold"
      >
        Custom
      </Text>
      <div className="custom-picker-color__selected">
        {colors.map((item: string) => {
          const classes = cx("custom-picker-color__color", {
            "is-selected": item === selectedColor,
          });
          return (
            // eslint-disable-next-line jsx-a11y/no-static-element-interactions, jsx-a11y/click-events-have-key-events
            <span
              className={classes}
              key={item}
              style={{ backgroundColor: item, color: item }}
              onClick={() => onChange(item)}
            />
          );
        })}
        <button
          type="button"
          className="custom-picker-color__plus"
          onClick={onAddCustomColor}
        >
          <Icon name="plus" size="S" color="currentColor" transition={true} />
        </button>
      </div>
    </div>
  );
};
